import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
  Navigate,
} from "react-router-dom";
import LoginPage from "@pages/login/Login";
import { Providers } from "./Provider";
import "./App.css";
import Dashboard from "@pages/dashboard/Dashboard";
import EvaluationPage from "@pages/evaluationpage/EvaluationPage";
import { AppToaster } from "@components/common/toaster/AppToaster";
import { AnimatePresence, motion } from "motion/react";

function AppContent() {
  const location = useLocation();
  return (
    <>
      <AnimatePresence mode="wait">
        <Routes location={location} key={location.pathname}>
          <Route path="/" element={<LoginPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
          <Route
            path="/dashboard"
            element={
              <motion.div
                initial={{ opacity: 0, scale: 0.75 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.75 }}
                transition={{ duration: 0.3 }}
              >
                <Dashboard />
              </motion.div>
            }
          />
          <Route
            path="/evaluation"
            element={
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.3 }}
              >
                <EvaluationPage />
              </motion.div>
            }
          />
        </Routes>
      </AnimatePresence>
    </>
  );
}

function App() {
  return (
    <Providers>
      <Router>
        <AppContent />
      </Router>
      <AppToaster />
    </Providers>
  );
}

export default App;
